<template>
  <div>
    <span class="circle" :style="`background-color: ${object.color}`"></span>{{ object.title }}
  </div>
</template>

<script>
export default {
  name: "SettingsDatatableTDTagTitle",
  props: {
    object: {
      type: Object
    }
  },
}
</script>

<style scoped lang="scss">
  .circle {
    margin-right: 12px;
  }
</style>
